import { Pressable, StyleSheet, Text, View } from "react-native";
import { ms } from "@/ui/moderateScale";
import { Colors } from "@/constants/Colors";
import Icon from "@/ui/Icon";
import { useTranslation } from "react-i18next";
import { useUISlice } from "@/models/useUISlice";

export const NoteTabs = ({
  items,
  onMorePress,
}: {
  onMorePress?: () => void;
  items: {
    selected?: boolean;
    title: string;
    onPress: () => void;
  }[];
}) => {
  const isMobile = useUISlice((state) => state.device.isMobile);
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      {items.map((item, index) => (
        <Pressable
          key={`${item.title}-${index}`}
          onPress={item.onPress}
          style={StyleSheet.flatten([
            styles.tab,
            item.selected && { backgroundColor: Colors.accent },
          ])}
        >
          <Text
            style={StyleSheet.flatten([
              styles.tabText,
              item.selected && { color: Colors.white },
            ])}
          >
            {item.title}
          </Text>
        </Pressable>
      ))}

      {onMorePress && (
        <Pressable
          onPress={onMorePress}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: ms(4),
            height: ms(32),
            // width: ms(48),
            paddingHorizontal: ms(12),
            justifyContent: "center",
            backgroundColor: Colors.text + "10",
            borderRadius: ms(80),
            borderWidth: 1,
            borderColor: Colors.gray3,
          }}
        >
          <Text style={{ ...styles.tabText, color: Colors.accent }}>
            {t("noteTabs.more")}
          </Text>
          <Icon
            icon="plus"
            style={{
              tintColor: Colors.accent,
              width: ms(16),
              height: ms(16),
            }}
          />
        </Pressable>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: ms(8),
  },
  tab: {
    paddingHorizontal: ms(16),
    height: ms(32),
    backgroundColor: Colors.text + "10",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: ms(80),
    borderColor: Colors.text + "30",
  },
  tabText: {
    fontSize: ms(12),
    fontWeight: "600",
    // letterSpacing: ms(0.5),
    color: Colors.subtitle,
  },
});
